import { adjustObject, evaluateOverlap, getLocalPolygon, getPolygonCoordinateSystem, mirrorPolygonBox, rotatePolygonBox90Deg, transformCoordinateUsingSystems, transformDirectionUsingSystems, } from "./ceilingUtils";
const generateRandomString = (chars) => {
    return Math.random()
        .toString(36)
        .substring(2, chars + 2);
};
export const copyDevicesFromASpaceToAnotherSpace = (args) => {
    if (args.spaceToCopyFrom.polygon == null || args.spaceToCopyTo.polygon == null) {
        return [];
    }
    let sourceBox = getPolygonCoordinateSystem(args.spaceToCopyFrom.polygon);
    let destinationBox = getPolygonCoordinateSystem(args.spaceToCopyTo.polygon);
    let bestOverlapFound = 0;
    let bestSource = sourceBox;
    let bestDestination = destinationBox;
    for (let mirror of [0, 1]) {
        for (let rot = 0; rot < 4; rot += 1) {
            const destinationPoly = getLocalPolygon(args.spaceToCopyTo.polygon, destinationBox);
            for (let ro = 0; ro < 4; ro += 1) {
                const sourcePoly = getLocalPolygon(args.spaceToCopyFrom.polygon, sourceBox);
                const sharedBox = JSON.parse(JSON.stringify(destinationBox));
                sharedBox.localMax = sharedBox.localMax.filter((val, index) => Math.max(val, sourceBox.localMax[index]));
                const overlap = evaluateOverlap(sharedBox, sourcePoly, destinationPoly);
                if (overlap > bestOverlapFound) {
                    bestOverlapFound = overlap;
                    bestSource = sourceBox;
                    bestDestination = destinationBox;
                }
                sourceBox = rotatePolygonBox90Deg(sourceBox);
            }
            destinationBox = rotatePolygonBox90Deg(destinationBox);
        }
        sourceBox = mirrorPolygonBox(sourceBox);
    }
    const targetCeilingGrids = args.spaceToCopyTo.ceilingGrids ?? [];
    return args.devicesToCopy.reduce((acc, device) => {
        if (device.coordinate == null || device.direction == null) {
            return acc;
        }
        const copyOfDevice = { ...device };
        const transformedCoordinate = transformCoordinateUsingSystems(device.coordinate, bestSource, bestDestination);
        const transformedDirection = transformDirectionUsingSystems(copyOfDevice.direction, bestSource, bestDestination);
        let finalCoordinate = transformedCoordinate;
        let finalDirection = transformedDirection;
        if (targetCeilingGrids.length > 0) {
            const adjusted = adjustObject({
                center: transformedCoordinate,
                direction: transformedDirection,
            }, targetCeilingGrids);
            finalCoordinate = adjusted.center;
            if (adjusted.direction && adjusted.direction.length > 1) {
                finalDirection = adjusted.direction;
            }
        }
        copyOfDevice.coordinate = finalCoordinate;
        copyOfDevice.direction = finalDirection;
        delete copyOfDevice._id;
        copyOfDevice._id = generateRandomString(5); // Temporary id before saving to db, required for viewer
        const newDevice = {
            ...copyOfDevice,
            floor: args.spaceToCopyTo.buildingStory?.name ?? copyOfDevice.floor,
            roomName: args.spaceToCopyTo.longName ?? args.roomToCopyTo?.roomName ?? copyOfDevice.roomName,
            roomNumber: args.spaceToCopyTo.name,
        };
        if (newDevice.deviceCategory === "SUPPLY_AIR_DEVICE") {
            newDevice.supplyAirFlow = args.roomToCopyTo?.supplyAirFlow ?? 0;
        }
        if (newDevice.deviceCategory === "RETURN_AIR_DEVICE") {
            newDevice.returnAirFlow = args.roomToCopyTo?.returnAirFlow ?? 0;
        }
        acc.push(newDevice);
        return acc;
    }, []);
};
